import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from "../config";

let options = {};
let headers = new Headers();
const token = sessionStorage.getItem("token");

headers.append('content-type', 'application/json');
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getSSLExpiration() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/sslcertificate/getexpiration`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}